<template>
  <!-- te-popup begin -->
  <div class="te-alert d-flex flex-column" @click.stop style="max-height:72vh;">
    <a v-if="display.close" class="close" style="z-index: 10; cursor: pointer" @click="close">
      <i class="material-icons">close</i>
    </a>
    <div class="content d-flex align-items-center flex-column flex-grow-1">
      <slot />
    </div>
    <div class="alert-btn">
      <button v-if="display.cancel" class="mx-1 btn btn-sm btn-light rounded-pill" @click="close">
        <span class="px-3">{{ cancelWording }}</span>
      </button>
      <button v-if="display.confirm"  class="mx-1 btn btn-sm btn-primary rounded-pill"
      :class="{'bg-customize border-customize': isCustomize}"
      @click="confirm">
        <span class="px-3">{{ confirmWording }}</span>
      </button>
    </div>
  </div>
  <!-- te-popup end -->
</template>

<script>
export default {
  props: {
    // 顯示設定
    display: {
      type: Object,
      default() {
        return {
          // 關閉鈕
          close: true,
          // 取消鈕
          cancel: true,
          // 確認鈕
          confirm: true,
        };
      },
    },
    // 取消按鈕文案
    cancelWording: {
      type: String,
    },
    // 確認按鈕文案
    confirmWording: {
      type: String,
    },
    // 是否客製按鈕
    isCustomize: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 關閉
    close() {
      this.$emit('close');
    },
    // 確認
    confirm() {
      const vm = this;
      vm.close();
      vm.$emit('confirm');
    },
  },
};
</script>
